import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output
} from "@angular/core";

import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { interceptorSkipHeader } from "../services/auth.interceptor";
import { Observable } from "rxjs/Observable";
import { AuthService } from "../services/auth.service";

export interface Error {
  type: string; // mostly, Python exception class
  message: string;
  traceback?: string[]; // Plone traceback
  errors?: {
    // mostly, dexterity fields validation errors
    field?: string;
    message?: string;
    error?: string;
    [x: string]: any;
  }[];
  response?: HttpErrorResponse;
  [x: string]: any;
}

export interface NamedFile {
  download: string; // download path
  filename: string;
  "content-type": string;
}

export interface DownloadStartedEvent {
  namedFile: NamedFile;
  originalEvent: Event;
}

export interface DownloadSucceededEvent {
  blob: Blob;
  namedFile: NamedFile;
}

export interface DownloadFailedEvent {
  error: Error;
  namedFile: NamedFile;
}

@Directive({
  selector: "[ploneDownload]"
})
export class PloneDownloadDirective {
  @Input() downloadFile: NamedFile;
  @Output() onBeforeDownloadStarted: EventEmitter<
    DownloadStartedEvent
  > = new EventEmitter();
  @Output() onDownloadSuccess: EventEmitter<
    DownloadSucceededEvent
  > = new EventEmitter();
  @Output() onDownloadFailed: EventEmitter<
    DownloadFailedEvent
  > = new EventEmitter();

  constructor(private http: HttpClient, private auth: AuthService) {}

  download(url: string): Observable<Blob | {}> {
    return this.http
      .get(url, {
        responseType: "blob",
        headers: new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + this.auth.jwt,
          [interceptorSkipHeader]: ""
        })
      })
      .pipe(
        map((blob: Blob) => {
          return blob;
        })
      );
  }

  @HostListener("click", ["$event"])
  onClick(event: Event) {
    if (!!event) {
      event.preventDefault();
    }
    const namedFile: NamedFile = this.downloadFile;
    this.onBeforeDownloadStarted.emit(<DownloadStartedEvent>{
      namedFile: namedFile,
      originalEvent: event
    });
    this.download(namedFile.download).subscribe(
      (blob: Blob | {}) => {
        if (blob instanceof Blob) {
          PloneDownloadDirective.saveDownloaded(namedFile, blob);
          this.onDownloadSuccess.emit(<DownloadSucceededEvent>{
            namedFile: namedFile,
            blob: blob
          });
        }
      },
      (error: Error) => {
        this.onDownloadFailed.emit(<DownloadFailedEvent>{
          error: error,
          namedFile: namedFile
        });
      }
    );
  }

  private static saveDownloaded(namedFile: NamedFile, blob: Blob) {
    const a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(
      new Blob([blob], { type: namedFile["content-type"] })
    );
    a.download = namedFile.filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/plone-download.directve.ts